import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  employee: {},
  errors: {},
  requesting: null,
  submitting: null,
  isSaved: false,
};

const Slice = createSlice({
  name: '@admin/Employees|Form',
  initialState,
  reducers: {
    
    /**
     * RESET
     */
    initialState: (state) => {
      state.requesting = null;
      state.submitting = null;
      state.errors = {};
      state.employee = {};
      state.isSaved = false;
    },

    /**
     * GET EMPLOYEE
     */
    getEmployee: (state) => {
      state.requesting = true;
      state.employee = {};
    },
    getEmployeeSuccess: (state, action) => {
      const { payload } = action;
      state.employee = payload;
      state.requesting = false;
    },
    getEmployeeFailed: (state, action) => {
      state.errors = action.payload;
      state.requesting = false;
    },

    /**
     * SAVE FORM
     */
    saveForm: (state) => {
      state.submitting = true;
      state.isSaved = false;
      state.errors = {};
    },
    saveFormSuccess: (state, action) => {
      const { payload } = action;
      state.employee = payload;
      state.submitting = false;
      state.isSaved = true;
    },
    saveFormFailed: (state, action) => {
      state.errors = action.payload;
      state.submitting = false;
      state.isSaved = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminEmployeesFormReducers: Slice.reducer,
}
export default Reducers;
